// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"6b0de408","513":"6c9b0040","703":"1ca1a611"}[chunkId] + ".chunk.js";
};